import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '@app/shared/shared.module';
import { CallBarringListComponent } from './components/call-barring-list/call-barring-list.component';
import { CallBarringPageComponent } from './components/call-barring-page/call-barring-page.component';
import { UpdateCallBarringComponent } from './components/update-call-barring/update-call-barring.component';

@NgModule({
  imports: [SharedModule, ReactiveFormsModule],
  declarations: [CallBarringListComponent, CallBarringPageComponent, UpdateCallBarringComponent],
  exports: [CallBarringListComponent],
})
export class CallBarringModule {}
